// Dior true card-deck gallery (mobile): vertical swipe.
// The next AND previous images sit UNDERNEATH the current one.
// The top card slides away with your finger, revealing the next underneath.
// No crossfade, no blend. Only the image moves, page stays still.
(function() {
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var DURATION = '1s';
  var EASE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
  var THRESHOLD = 60;

  document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach(function(gallery) {
    var slider = gallery.querySelector('ul[id^="Slider-Gallery-"]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('li[id^="Slide-"]'));
    if (!slider || slides.length < 2) return;

    var current = 0;
    var startY = 0;
    var deltaY = 0;
    var dragging = false;
    var animating = false;

    function idx(n) {
      var len = slides.length;
      return ((n % len) + len) % len;
    }

    var fixedH = 0;
    function setHeight() {
      slider.style.aspectRatio = '1 / 1';
      slider.style.height = 'auto';
      var w = slider.offsetWidth || slider.clientWidth;
      if (w > 0) {
        fixedH = w;
      }
    }

    function paint(instant) {
      var next = idx(current + 1);
      var prev = idx(current - 1);
      slides.forEach(function(slide, i) {
        slide.style.transition = instant ? 'none' : 'transform ' + DURATION + ' ' + EASE;
        slide.style.transform = 'translateY(0)';
        slide.style.visibility = 'visible';
        if (i === current) {
          slide.style.zIndex = '10';
        } else if (i === next || i === prev) {
          slide.style.zIndex = '5';
        } else {
          slide.style.zIndex = '1';
          slide.style.visibility = 'hidden';
        }
      });
    }

    function updateCounter() {
      var counter = gallery.querySelector('[id^="SlideCounter-"], .slider-counter');
      if (counter) {
        var cur = counter.querySelector('.slider-counter--current');
        var total = counter.querySelector('.slider-counter--total');
        if (cur) cur.textContent = String(current + 1);
        if (total) total.textContent = String(slides.length);
      }
    }

    function goTo(n, dir) {
      if (animating) return;
      var target = idx(n);
      if (target === current) {
        paint(false);
        return;
      }
      animating = true;
      var off = dir >= 0 ? '-100%' : '100%';
      var top = slides[current];
      top.style.transition = 'transform ' + DURATION + ' ' + EASE;
      top.style.transform = 'translateY(' + off + ')';
      top.style.zIndex = '10';
      setTimeout(function() {
        current = target;
        paint(true);
        updateCounter();
        setHeight();
        requestAnimationFrame(function() {
          paint(false);
          animating = false;
        });
      }, 1000);
    }

    function setup() {
      if (!MOBILE.matches) return;
      slider.style.position = 'relative';
      slider.style.overflow = 'hidden';
      slider.style.touchAction = 'none';
      slider.style.display = 'block';
      slides.forEach(function(slide) {
        slide.style.position = 'absolute';
        slide.style.top = '0';
        slide.style.left = '0';
        slide.style.width = '100%';
        slide.style.height = '100%';
        slide.style.margin = '0';
      });
      paint(true);
      updateCounter();
      setHeight();
      setTimeout(setHeight, 500);
    }

    var thumbs = gallery.querySelectorAll('[id^="Thumbnail-"], .thumbnail');
    Array.prototype.forEach.call(thumbs, function(thumb, i) {
      thumb.addEventListener('click', function(e) {
        if (MOBILE.matches && i < slides.length && i !== current) {
          e.preventDefault();
          e.stopPropagation();
          goTo(i, i > current ? 1 : -1);
        }
      });
    });

    gallery.addEventListener('slideChanged', function(e) {
      if (MOBILE.matches && e.detail && e.detail.currentPage) {
        var p = e.detail.currentPage - 1;
        if (p !== current) goTo(p, p > current ? 1 : -1);
      }
    });

    slider.addEventListener('touchstart', function(e) {
      if (!MOBILE.matches || animating) return;
      e.stopPropagation();
      startY = e.touches[0].clientY;
      deltaY = 0;
      dragging = true;
      slides[current].style.transition = 'none';
    }, { passive: true });

    slider.addEventListener('touchmove', function(e) {
      if (!dragging || !MOBILE.matches) return;
      e.preventDefault();
      e.stopPropagation();
      deltaY = e.touches[0].clientY - startY;
      if (Math.abs(deltaY) < 8) deltaY = 0;
      slides[current].style.transform = 'translateY(' + deltaY + 'px)';
    }, { passive: false });

    slider.addEventListener('touchend', function(e) {
      if (!dragging || !MOBILE.matches) return;
      if (e && e.stopPropagation) e.stopPropagation();
      dragging = false;
      if (deltaY < -THRESHOLD) {
        goTo(current + 1, 1);
      } else if (deltaY > THRESHOLD) {
        goTo(current - 1, -1);
      } else {
        deltaY = 0;
        paint(false);
      }
      deltaY = 0;
    });

    slider.addEventListener('touchcancel', function() {
      dragging = false;
      deltaY = 0;
      if (MOBILE.matches) paint(false);
    });

    window.addEventListener('load', setHeight);
    window.addEventListener('load', setup);
    if (document.readyState === 'complete') setup();
    MOBILE.addEventListener('change', setup);
  });
})();
